import clsx from 'clsx';
import { ComponentPropsWithoutRef, forwardRef } from 'react';

export type RegistryTableColProps = ComponentPropsWithoutRef<'colgroup'>;

export const createRegistryTableCol = () => {
	const RegistryTableCol = forwardRef<HTMLTableColElement, RegistryTableColProps>(
		({ className, ...props }, ref) => (
			<col
				ref={ref}
				className={clsx('registry-table-col', className)}
				{...props}
			/>
		),
	);

	return RegistryTableCol;
};
